const value = {
    PROJECT: 'Проект',
    APPLICATION: 'Анкета АС',
    JIRA: 'Jira',
    REQUIREMENT: 'Требования',
    REQUIREMENT_TEMPLATE: 'Шаблон требований',
    TRANSFER_APPLICATION: 'Анкета АС',
    REQUIREMENT_ACCEPT: 'Обновление частного набора требований к АС',
  };

export default value;
